import React from 'react';

import {
  Container,
  NotFoundContent,
  NotFoundImage,
  NotFoundTitle,
  NotFoundText,
  Footer,
} from './styles';

import notFoundImage from '../../../../assets/images/icons/not-found.webp';
import notFoundImageDark from '../../../../assets/images/icons/not-found-dark.webp';
import {StyleProp, ViewStyle, useColorScheme} from 'react-native';
import {Button} from '../../Forms/Buttons/Button';
import { SafeAreaView } from 'react-native-safe-area-context';

interface INotFound {
  title?: string;
  text?: string;
  style?: StyleProp<ViewStyle>;
  onRetry?: () => void;
  pointerEvents?: 'auto' | 'none' | 'box-none' | 'box-only';
}

export function NotFound({
  title,
  text,
  style,
  onRetry,
  pointerEvents = 'auto',
}: INotFound) {
  const colorScheme = useColorScheme();
  return (
    <Container style={style} pointerEvents={pointerEvents}>
      <NotFoundContent>
        <NotFoundImage
          source={colorScheme === 'light' ? notFoundImage : notFoundImageDark}
        />
        <NotFoundTitle>
          {title ? title : 'Não encontramos nenhum resultado'}
        </NotFoundTitle>
        <NotFoundText style={{marginBottom: 16}}>
          {text ? text : 'Tente buscar usando outros termos ou palavras-chave.'}
        </NotFoundText>
      </NotFoundContent>

      {onRetry && (
      
        <Footer>
          <Button enabled title="Selecionar outra região" onPress={onRetry} />
        </Footer>

      )}
    </Container>
  );
}
